'use client';
import Link from "next/link";
import { BsTwitterX } from "react-icons/bs";
import { RiTelegram2Line } from "react-icons/ri";
import Image from "next/image";
import CommunityLink from "./communityLink";
import CommunityBanner from "../CommunityBanner";
import { usePathname } from "next/navigation";
const contractAddress = "";

export default function Footer() {

  const pathname = usePathname();
  const isDocsPage = pathname?.startsWith('/docs');
  return (
    <footer className={`${isDocsPage ? "bg-[#29114b]" : "bg-[#5752b4]"}  text-white  p-4 md:p-10 relative`}>
      {/* Decorative cat paw prints */}
      {/* <div className="absolute top-0 left-0 right-0 h-8 overflow-hidden">
        <div className="flex justify-between">
          {[...Array(8)].map((_, i) => (
            <div
              key={i}
              className="w-8 h-8 bg-purple-500/20 rounded-full transform rotate-45"
            />
          ))}
        </div>
      </div> */}

      <div className="max-w-7xl mx-auto">
        {/* Main footer content */}
        <div className="grid md:grid-cols-4 gap-8 mb-4 sm:mb-8">
          {/* Column 1 - Main CTA */}
          <div className="md:col-span-2 flex flex-col gap-2">
            <CommunityBanner />
          </div>

          {/* Column 2 - Quick Links  */}
          <div>
            <h3 className="text-xl font-bold mb-6 border-l-4 border-indigo-500 pl-3">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/docs"
                  className="text-gray-300 hover:text-lime-400 flex items-center group transition-all"
                >
                  <span className="mr-2 group-hover:mr-3 transition-all">
                    •
                  </span>
                  <span className="group-hover:translate-x-2 transition-transform">
                    Docs
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  href="/dna-archive"
                  className="text-gray-300 hover:text-lime-400 flex items-center group transition-all"
                >
                  <span className="mr-2 group-hover:mr-3 transition-all">
                    •
                  </span>
                  <span className="group-hover:translate-x-2 transition-transform">
                    DNA Archive
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  href="/"
                  className="text-gray-300 hover:text-lime-400 flex items-center group transition-all"
                >
                  <span className="mr-2 group-hover:mr-3 transition-all">
                    •
                  </span>
                  <span className="group-hover:translate-x-2 transition-transform">
                    Cat DNA Tree
                  </span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Community */}
          <div>
            <h3 className="text-xl font-bold mb-4 border-l-4 border-indigo-500 pl-3">
              Join Our Community
            </h3>
            <div className="flex flex-wrap gap-4">
              <CommunityLink href="https://x.com/CatDevAi">
                <BsTwitterX className="w-5 h-5" />
              </CommunityLink>
              <CommunityLink href="https://t.me/CatDevAi">
                <RiTelegram2Line className="w-5 h-5" />
              </CommunityLink>
              <CommunityLink
                href={
                  contractAddress
                    ? `https://jup.ag/swap/SOL-${contractAddress}`
                    : "/"
                }
                target={contractAddress ? "_blank" : "_self"}
              >
                <Image
                  width={24}
                  height={24}
                  src={"/assests/jupiter-logo.webp"}
                  className="w-5 h-5 grayscale brightness-200"
                  alt="icon jup.ag"
                />
              </CommunityLink>
              <CommunityLink
                href={
                  contractAddress
                    ? `http://dexscreener.com/solana/${contractAddress}`
                    : "/"
                }
                target={contractAddress ? "_blank" : "_self"}
              >
                <Image
                  width={24}
                  height={24}
                  src={"/assests/dex.svg"}
                  className="w-5 h-5"
                  alt="dexscreener"
                />
              </CommunityLink>
              <CommunityLink href="/">
                <Image
                  width={24}
                  height={24}
                  src={"/assests/pump_buy_logo.png"}
                  alt="icon pump-buy"
                  className="w-5 h-5 grayscale"
                />
              </CommunityLink>
            </div>
          </div>
        </div>

        {/* Bottom footer */}
        <div className="border-t border-indigo-500/50 pt-2 mt-2">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 CatDev. All rights reserved. 🐾
            </p>
            {/* <div className="flex gap-4 text-sm text-gray-400">
              <Link href="/privacy" className="hover:text-purple-400">
                Privacy Policy
              </Link>
              <Link href="/terms" className="hover:text-purple-400">
                Terms of Service
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
}
